import RestService from "model/service/dataStorage/RestService";
import IRestServiceOptions from "../../interface/api/IRestServiceOptions";

export type SupportedChartType = 'bar' | 'line' | 'pie' | 'donut';

export interface ApexChartSeriesItem {
    name: string;
    data: number[];
}

export interface ApexChartOptions {
    chart?: {
        id?: string;
    };
    title?: {
        text?: string;
    };
    xaxis?: {
        categories?: string[];
    };
}

export interface ApexChartConfig {
    type: SupportedChartType;
    series: ApexChartSeriesItem[];
    options: ApexChartOptions;
}

export interface IRestDataAnalystServiceCollectionResponse<T = Record<string, unknown>> {
    success: boolean;
    dql: string;
    summary: string;
    chart: ApexChartConfig | null;
    data: T[];
    error?: string;
    sessionId: string;
}

interface IRestAiDataAnalystService {
    collectionList(options?: IRestServiceOptions): Promise<IRestDataAnalystServiceCollectionResponse>;
}

const AiDataAnalystService_COLLECTION = 'ai-data-analyst';

const AiDataAnalystService: IRestAiDataAnalystService = {
    collectionList: function (options?) {
        return RestService.customRetrieve<IRestDataAnalystServiceCollectionResponse>(
            AiDataAnalystService_COLLECTION,
            options as unknown as IRestServiceOptions
        );
    }
};

export default AiDataAnalystService;